// Dutch. Keys omitted here fall back to English (see src/i18n/index.js).
// "RPilot" is a brand name and stays untranslated.
export default {
  // Common actions
  'common.cancel': 'Annuleren',
  'common.submit': 'Versturen',
  'common.save': 'Opslaan',
  'common.create': 'Aanmaken',
  'common.delete': 'Verwijderen',
  'common.close': 'Sluiten',
  'common.retry': 'Opnieuw',
  'common.confirm': 'Bevestigen',
  'common.areYouSure': 'Weet je het zeker?',

  // Chat surface
  'chat.startConversation': 'Begin een gesprek',
  'chat.inputPlaceholder': 'Typ een bericht...',
  'chat.inputPlaceholderNoCredits': 'Geen RPilot-credits meer',
  'chat.creditsUsedUpFooter': 'De RPilot-credits van je team zijn op. Begin een nieuwe chat zodra de credits zijn vernieuwd.',
  'chat.newChat': 'Nieuwe chat',
  'chat.useSkill': 'Gebruik een skill',
  'chat.skills': 'Skills',
  'chat.loadingSkills': 'Skills laden…',
  'chat.noSkill': 'Geen skill',
  'chat.noSkillsAvailable': 'Geen skills beschikbaar',
  'chat.appliesNextMessage': 'Geldt vanaf je volgende bericht',
  'chat.attachImage': 'Afbeelding toevoegen',
  'chat.attachFile': 'Bestand toevoegen',
  'chat.fileTooLarge': 'Bestand is te groot (max {size})',
  'chat.uploadFailed': 'Uploaden mislukt',
  'chat.download': 'Downloaden',
  'chat.recordVoice': 'Spraak opnemen',
  'chat.stopRecording': 'Opname stoppen',
  'chat.stop': 'Stoppen',
  'chat.send': 'Versturen',
  'chat.thinking': 'Aan het denken…',
  'chat.thoughtProcess': 'Denkproces',
  'chat.waitingForHost': 'Wachten op het dashboard…',
  'chat.thinkingComplete': 'Denken afgerond',
  'chat.toolUsedOne': '1 tool gebruikt',
  'chat.toolsUsedCount': '{count} tools gebruikt',
  'chat.usedNames': '{names} gebruikt',
  'chat.usedToolsCount': '{count} tools gebruikt',
  'chat.running': 'bezig',
  'chat.details': 'Details',
  'chat.arguments': 'Argumenten',
  'chat.result': 'Resultaat',
  'chat.error': 'Fout',
  'chat.done': 'Klaar',
  'chat.openInNewTab': 'Openen in nieuw tabblad',
  'chat.openInDocsSite': 'Openen in documentatie',
  'chat.noPageContent': 'Geen inhoud beschikbaar voor deze pagina.',
  'chat.goodResponse': 'Goed antwoord',
  'chat.badResponse': 'Slecht antwoord',
  'chat.whatWentWrong': 'Wat ging er mis?',
  'chat.optionalFeedback': 'Optionele feedback...',

  // Tool approval
  'approval.required': 'Goedkeuring vereist',
  'approval.requiredCount': 'Goedkeuring vereist — {count} acties',
  'approval.approve': 'Goedkeuren',
  'approval.deny': 'Weigeren',
  'approval.approveAll': 'Alles goedkeuren',
  'approval.approveSelected': 'Selectie goedkeuren ({count})',
  'approval.denyAll': 'Alles weigeren',
  'approval.andMore': '…en nog {count}',
  'approval.approvedChip': 'Goedgekeurd',
  'approval.deniedChip': 'Geweigerd',
  'approval.timedOutChip': 'Verlopen',
  'approval.countApproved': '{count} goedgekeurd',
  'approval.countDenied': '{count} geweigerd',
  'approval.countTimedOut': '{count} verlopen',
  'approval.timedOut': 'verlopen',
  'approval.settled': 'afgehandeld',

  // Header / drawer
  'header.expand': 'Uitklappen',
  'header.collapse': 'Inklappen',
  'header.menu': 'Menu',
  'drawer.sessions': 'Sessies',
  'drawer.skills': 'Skills',
  'drawer.settings': 'Instellingen',
  'drawer.noSessions': 'Nog geen sessies',
  'drawer.chatFallbackTitle': 'Chat {id}',
  'drawer.newSkill': 'Nieuwe skill',
  'drawer.searchSkills': 'Skills zoeken...',
  'drawer.noSkillsMatch': 'Geen skills gevonden voor je zoekopdracht.',
  'drawer.noSkillsYet': 'Nog geen skills. Maak er een aan om te beginnen.',
  'drawer.mySkills': 'Mijn skills',
  'drawer.builtIn': 'Ingebouwd',
  'drawer.shared': 'Gedeeld',
  'drawer.showToolCalls': 'Tool-aanroepen tonen',
  'drawer.autoAcceptEdits': 'Wijzigingen automatisch accepteren',
  'drawer.darkMode': 'Donkere modus',
  'drawer.version': 'Versie',
  'drawer.versionCopied': 'Gekopieerd',

  // Credit gate / usage / exhaustion
  'gate.meetTitle': 'Maak kennis met RPilot',
  'gate.meetBody': 'RPilot is je AI-assistent voor RDrive. Stel vragen over tekeningen, issues, planningen en projectdata in gewone taal en krijg heldere antwoorden met directe links naar de app.',
  'gate.meetCta': 'Wil je RPilot voor je team? Neem contact op met ons salesteam',
  'gate.outOfCreditsTitle': 'Je RPilot-credits zijn op',
  'gate.outOfCreditsBody': 'De RPilot-credits van je team zijn op. Neem contact op om te verlengen en ga verder waar je gebleven was.',
  'credits.title': 'Creditverbruik',
  'credits.loadFailed': 'Kon het creditverbruik niet laden.',
  'credits.active': 'Actief',
  'credits.fallback': 'Reserve',
  'credits.exhausted': 'op',
  'credits.noPools': 'Geen creditpools',
  'credits.daily': 'Dagelijks',
  'credits.weekly': 'Wekelijks',
  'credits.monthly': 'Maandelijks',
  'credits.dayShort': 'D',
  'credits.weekShort': 'W',
  'credits.monthShort': 'M',
  'credits.usedNoLimit': '{label} — {spent} gebruikt (geen limiet)',
  'credits.balanceLine': 'Saldo: {balance} credits · reset om middernacht {zone}',
  'credits.account': 'Account',
  'credits.scopeProject': 'Project',
  'credits.scopeTeam': 'Team',
  'credits.scopeMixed': 'Gemengd',
  'credits.scopePool': 'Pool',
  'credits.messageNotSent': 'De RPilot-credits van je team zijn op, dus dit bericht kon niet worden verstuurd. Je gesprek is bewaard.',
  'credits.contactUs': 'Neem contact op',

  // Contact sales
  'sales.contactSales': 'Contact met sales',
  'sales.requestReceived': 'Aanvraag ontvangen ✓',
  'sales.submitAgain': 'Opnieuw versturen',
  'sales.name': 'Naam',
  'sales.workEmail': 'Zakelijk e-mailadres',
  'sales.companyTeam': 'Bedrijf / team (optioneel)',
  'sales.message': 'Bericht (optioneel)',
  'sales.nameRequired': 'Naam is verplicht',
  'sales.emailRequired': 'Zakelijk e-mailadres is verplicht',
  'sales.emailInvalid': 'Voer een geldig e-mailadres in',
  'sales.thanks': 'Bedankt — ons team neemt contact met je op.',
  'sales.alreadyReceived': 'We hebben je aanvraag al ontvangen — we nemen contact met je op.',
  'sales.genericError': 'Er ging iets mis. Probeer het opnieuw.',
  'sales.speakWithSales': 'Praat met sales',
  'sales.salesChatPrefill': 'Hallo, ik wil graag met sales praten over RPilot voor mijn team.',

  // Auth gate

  // Skill editor
  'skill.newSkill': 'Nieuwe skill',
  'skill.editTitle': 'Bewerken — {name}',
  'skill.viewTitle': '{name}',
  'skill.readOnlyHint': 'Dit is een ingebouwde skill die door RDrive wordt beheerd en niet kan worden bewerkt. Om deze voor dit project aan te passen, maak je een gedeelde skill met dezelfde naam aan — die krijgt hier voorrang.',
  'skill.name': 'Naam',
  'skill.nameHint': 'kebab-case-naam',
  'skill.nameRule': 'Moet kebab-case zijn (bijv. review-rfi)',
  'skill.shared': 'Gedeeld',
  'skill.description': 'Beschrijving',
  'skill.descriptionPlaceholder': 'Wat deze skill doet en wanneer je hem gebruikt',
  'skill.required': 'Verplicht',
  'skill.tags': 'Tags',
  'skill.tagsPlaceholder': 'Typ en druk op Enter',
  'skill.allowedTools': 'Toegestane tools',
  'skill.allToolsAllowed': 'Alle tools toegestaan',
  'skill.instructions': 'Instructies (Markdown)',
  'skill.contentRequired': 'Inhoud is verplicht',
  'skill.deleteTitle': 'Skill verwijderen',
  'skill.deleteMessage': 'Skill "{name}" verwijderen? Dit kan niet ongedaan worden gemaakt.',

  // Location picker
  'picker.selectLocation': 'Locatie selecteren',
  'picker.searchDrawings': 'Tekeningen zoeken...',
  'picker.planViewerFailed': 'Kon de planviewer niet laden',
  'picker.selectDrawing': 'Selecteer een tekening om te bekijken',
  'picker.tapToPlace': 'Tik op een locatiepin om het issue te plaatsen',
  'picker.pinPlaced': 'Pin geplaatst',

  // Markdown editor toolbar
  'md.bold': 'Vet',
  'md.italic': 'Cursief',
  'md.heading': 'Kop',
  'md.inlineCode': 'Inline code',
  'md.codeBlock': 'Codeblok',
  'md.link': 'Link',
  'md.bulletList': 'Opsomming',
  'md.numberedList': 'Genummerde lijst',
  'md.blockquote': 'Citaat',
  'md.nothingToPreview': 'Niets om te tonen',
}
